import React, { useEffect, useState } from "react";
import { Form, message, Select } from "antd";
import strings from "../../utils/Localization";
import { api } from "../../helpers/ApiHelper";

const { Option } = Select;

function BankaHesapSelectOption({
  formItemName,
  formItemLabel,
  required,
  placeholder,
  hidden,
  showDovizKod = false,
  requestBody = {},
  rules,
  disabled,
  onSelectedBankaHesap = () => {},
  allowClear,
}) {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [bankaHesapData, setBankaHesapData] = useState([]);
  useEffect(() => {
    fetchBankaHesap();
  }, [requestBody]); // eslint-disable-line react-hooks/exhaustive-deps
  const fetchBankaHesap = async () => {
    try {
      setFetchLoading(true);
      const response = await api.post("/bankahesap/get", {
        Includes: ["Doviz"],
        SortOptions: {
          ColumnName: "Id",
          SortType: "Asc",
        },
        ...requestBody,
      });
      if (response.status === 200) {
        setBankaHesapData(response.data.data);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Form.Item
      name={formItemName}
      label={formItemLabel}
      rules={
        rules
          ? rules
          : [{ required: required, message: strings.mesaj.gerekliBirAlan }]
      }
      hidden={hidden}
    >
      <Select
        placeholder={placeholder || strings.bankaHesapSelectOption.placeHolder}
        loading={fetchLoading}
        onChange={(e) =>
          onSelectedBankaHesap(bankaHesapData.find((x) => x.id === parseInt(e)))
        }
        disabled={disabled}
        allowClear
      >
        {bankaHesapData.map((item, index) => (
          <Option key={index} value={String(item.id)}>
            {`${item.ad} ${showDovizKod ? "(" + item.doviz.kod + ")" : ""}`}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default BankaHesapSelectOption;
